function Intro() {
    return (
        <div className="dpFlx jcC aiC h550">
            <span className="fs50 fcBlack">메인화면 영역입니다.</span>
        </div>
    );
}
export default Intro;